<template>
  <div class="faq_list">
    <FAQHeader
      :content="content"
      :unic_id="_.get(this.contentData, 'conf.unicId')"
      :title="_.get(this.contentData, 'conf.header.title')"
    />
    <div class="faq_list__inner bg_white wc-lg">
      <FaqItem
        v-for="(item, index) in $store.state.main.faq_content"
        :key="index"
        :question="item.title"
        :answer="item.answer"
        :tags="item.tags_faq"
      />
    </div>
  </div>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
import FAQHeader from "@/components/modules/FAQHeader";
import FaqItem from "@/components/modules/FaqItem.vue";
export default {
  props: ["contentData"],
  mixins: [resize_handler],
  components: {
    FAQHeader,
    FaqItem
  },
  data() {
    return {
      date_picked: "",
      active_calendar: false,

      modelConfig: {
        start: {
          timeAdjust: "00:00:00"
        },
        end: {
          timeAdjust: "23:59:59"
        }
      }
    };
  },
  computed: {
    page_count() {
      this.$store.state.main.faq_page_count = _.get(
        this.contentData,
        "conf.page_count"
      );
      return _.get(this.contentData, "conf.page_count");
    },
    uniq_id() {
      return _.get(this.contentData, "conf.unicId");
    },

    content() {
      return _.get(this.contentData, "data.list");
    }
  },
  created() {
    this.$store.state.main.faq_content = _.get(this.contentData, "data.list");
    this.$store.state.main.faq_content_orig = _.get(
      this.contentData,
      "data.list"
    );
  },
  mounted() {
    // console.log(this.faq_content.length)
    // console.log(this.page_count);
    console.log(this.content);
  },

  methods: {},
  watch: {}
};
</script>
